module.exports = __webpack_public_path__ + "static/media/chest_spritesheet.333ae479.png";